<template>
  <section class="contenedor testimoniales mtop-neg-10 bg-blanco sombra">
    <h2><span>Lo que dicen</span>nuestros clientes</h2>
    <div class="testimonial">
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus fugit eaque non ratione minima iste, pariatur inventore autem quos, excepturi magni!</p>
      <p class="autor">Juan Pérez</p>
    </div>
  </section>  
</template>

<style scoped>
.testimoniales {
  padding: 5rem;
}
@media (min-width: 768px) {
  .testimoniales {
    padding: 10rem;
  }
}

.testimonial {
  background-color: #ebe7de;
  box-shadow: 2px 2px 8px #000;
  padding: 2rem;
  max-width: 50rem;
  margin: 0 auto;
  border-radius: 1rem;
}
.testimonial .autor {
  text-align: right;
  font-family: "Bona Nova", serif;
  color: #5e311e;
  font-size: 2rem;
}
.testimonial .autor::before {
  content: "- ";
}
</style>